export default {
  namespaced: true,
  actions: {
    name: "Action | Actions",
    add: "Add",
    accept: "Accept",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    filter: "Filter | Filters",
    update: "Update",
    export: "Export",
    close: "Close",
    save: "Save",
    save_changes: "Save changes",
    send: "Send",
    download: "Download",
    reset: "Reset",
    drag_drop_1: "Drag and drop to upload content!",
    drag_drop_2: "...or click to select a file from your computer",
    load: "Load",
    refresh: "Refresh",
    next: "Next",
    previous: "Previous",
    go_back: "Go back",
    finish: "Finish",
    delete_all: "Delete all",
    select_deselect_all: "Select/Deselect all",
    validate: "Validate",
    sync: "Sync",
    synchronizing: "Synchronizing",
    showMore: "Show more",
    clone: "Clone",
    show: "Show",
    refresh_table: "Refresh Table",
    collapse: "Collapse",
    expand: "Expand",
    start: "Start",
    stop: "Stop",
    pause: "Pause",
    approve: "Approve",
    reject: "Reject",
    status: "Status",
    exit: "Exit",
    syncing: "Syncing",
    saving: "Saving",
    loading: "Loading",
    view_document: "View document",
    file_upload: {
      accepted_types_label: "Accepted types:",
      accepted_types_value: "Images, PDF, Word, Excel, PowerPoint.",
      max_label: "Maximum:",
      max_per_document: "30 MB per document",
      max_documents_total: "5 documents in total",
      tooltip: "Images: JPG, JPEG, PNG, GIF, BMP, WEBP, SVG<br>Documents: PDF<br>Word: DOC, DOCX, ODT, RTF<br>Excel: XLS, XLSX, CSV, ODS",
      select_files: "Select files...",
      browse: "Browse",
      max_documents_error: "Maximum {n} documents allowed",
      max_size_error: "{name}: exceeds maximum size of {n} MB",
      uploading: "Uploading file(s)...",
      deleting: "Deleting file...",
    },
    search: "Search",
    download_document: "Download document",
  },
};
